import { reduxForm } from 'redux-form';

import ClientMembershipForm from './ClientMembershipForm';

export default reduxForm({ form: 'clientMembershipForm' })(ClientMembershipForm as any) as any;
